// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import GetItemRequest from '../contract/GetItemRequest';

export default function getItemRequest(data: GetItemRequest): GetItemRequest {
    let result: GetItemRequest = {
        __type: 'GetItemRequest:#Exchange',
        ...data,
    };

    return result;
}
